import clsx from 'clsx'
import { BADGE_LOOKS, badgeGlyph, foundingHex } from 'lib/community/model'
import type { CommunityBadgeId } from 'lib/community/types'
import FoundingHex from './FoundingHex'
import styles from './Badges.module.css'

/**
 * Every badge is a hexagon (Member Hub 2c/3d — one shape, so a new badge never needs a new
 * glyph family). An earned Early Owner / Founding Member keeps its own face (`FoundingHex`: the
 * number and DealHunt's cap); every other earned badge is its tone; anything not earned is the
 * grey `locked` hexagon with the badge's glyph. Decorative: the name and status sit beside it.
 */
const BadgeHex: React.VFC<{
  badge: { id: CommunityBadgeId; earned: boolean; detail?: string; number?: number }
  /** The member's stored numbers, for the founding faces; absent = DealHunt's badge `number`. */
  member?: { founding_number: number | null; founding_member_number?: number | null }
  /** The summary's Early Owner cap (`foundingCapOf`), printed on its hexagon. */
  foundingCap?: number | null
  className?: string
}> = ({ badge, member, foundingCap = null, className }) => {
  const founding = foundingHex(
    { ...badge, detail: badge.detail ?? '' },
    member ?? { founding_number: null },
    foundingCap
  )
  if (founding) {
    return <FoundingHex view={founding} className={className} />
  }
  const tone = badge.earned ? BADGE_LOOKS[badge.id].tone : 'locked'
  return (
    <span className={clsx(styles.hex, styles[`badge_${tone}`], className)} aria-hidden="true">
      <span className={styles.hexFill}>{badgeGlyph(badge, foundingCap)}</span>
    </span>
  )
}

export default BadgeHex
